import React from "react";
import { Alert, AlertTitle, Box, Stack } from "@mui/material";

const AlertPopup = ({ finalErr, handleClosed }) => {
  return (
    <>
      <Box>
        <Stack
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Alert
            severity="error"
            sx={{ width: "80%", borderRadius: "15px" }}
            onClose={handleClosed}
            // onClose={onClose}
          >
            <AlertTitle>Error</AlertTitle>
            <strong>{finalErr}</strong>
          </Alert>
        </Stack>
      </Box>
    </>
  );
};

export default AlertPopup;
